import { Injectable } from '@angular/core';
import { Observable, throwError, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IConfirmation } from '../../../models/IConfirmation';
import { get, post, patch, del } from 'aws-amplify/api';

@Injectable({
    providedIn: 'root'
})
export class ClassRosterService {
    private programId: any;
    private classId: any;
    private mode: any;
    public target: any;
    private copy: any;
    private data: any;
    private dirty: boolean = false;

    edit(programId, classId, mode, target, copy = null) {
        this.programId = programId;
        this.classId = classId;
        this.mode = mode;
        this.target = target;
        this.copy = copy;
    }

    editMode(): string {
        return this.mode;
    }

    original(): any {
        return this.copy;
    }

    update(data?: any) {
        if (data) {
            this.dirty = true;
            this.data = data;
        }
        return this.data;
    }

    isDirty(): boolean {
        return this.dirty;
    }

    save() {
        if (this.target == "participant") {
            switch (this.mode) {
                case "insert":
                    return this.insertParticipantTimeMissed();
                case "update":
                    return this.updateParticipantTimeMissed();
                case "delete":
                    return this.deleteParticipantTimeMissed();
            }
        } else if (this.target == "facilitator") {
            switch (this.mode) {
                case "insert":
                    return this.insertFacilitatorMissingTime();
                case "update":
                    return this.updateFacilitatorMissingTime();
                case "delete":
                    return this.deleteFacilitatorMissingTime();
            }
        } else if (this.target == "checkInStatus") {
            return this.updateCheckIn();
        } else if (this.target == "facilitationResponse") {
            return this.facilitationResponse();
        } else if (this.target == "facilitation") {
            switch (this.mode) {
                case "insert":
                    return this.insertFacilitation();
                case "update":
                    return this.updateFacilitation();
                case "delete":
                    return this.deleteFacilitation();
            }
        } else if (this.target == "participation") {
            switch (this.mode) {
                case "insert":
                    return this.insertParticipation();
                case "update":
                    return this.updateParticipation();
                case "delete":
                    return this.deleteParticipation();
            }
        }
    }

    cancel() {
        this.dirty = false;
    }

private apiGet<T>(path: string): Observable<T> {
  const op = get({ apiName: 'portal', path });
  return from(op.response.then(async (r) => (await r.body.json()) as T));
}
private apiPost<T>(path: string, body?: unknown): Observable<T> {
  const safeBody =
    body === undefined ? undefined : (JSON.parse(JSON.stringify(body)) as Record<string, any>);
  const op = post({
    apiName: 'portal',
    path,
    options: safeBody !== undefined ? { body: safeBody } : {},
  });
  return from(op.response.then(async (r) => (await r.body) as T));
}
private apiPatch<T>(path: string, body?: unknown): Observable<T> {
  const safeBody =
    body === undefined ? undefined : (JSON.parse(JSON.stringify(body)) as Record<string, any>);
  const op = patch({
    apiName: 'portal',
    path,
    options: safeBody !== undefined ? { body: safeBody } : {},
  });
  return from(op.response.then(async (r) => (await r.body) as T));
}
private apiDel<T>(path: string, body?: unknown): Observable<T> {
  const safeBody =
    body === undefined ? undefined : (JSON.parse(JSON.stringify(body)) as Record<string, any>);
  const op = del({
    apiName: 'portal',
    path,
    options: safeBody !== undefined ? { body: safeBody } : {},
  });
  return from(op.response.then(async (r) => (await r.body) as T));
}

/* eslint-disable @typescript-eslint/no-unused-vars */

private updateCheckIn() {
  const path = `programs/${this.programId}/courses/${this.classId}/participants`;
  return this.apiPatch<any>(path, this.data).pipe(map(() => {}));
}
private insertParticipantTimeMissed() {
  const path = `programs/${this.programId}/courses/${this.classId}/participants`;
  return this.apiPost<any>(path, this.data).pipe(map(() => {}));
}
private updateParticipantTimeMissed() {
  const path = `programs/${this.programId}/courses/${this.classId}/participants`;
  return this.apiPatch<any>(path, this.data).pipe(map(() => {}));
}
private deleteParticipantTimeMissed() {
  const path = `programs/${this.programId}/courses/${this.classId}/participants`;
  return this.apiDel<any>(path, this.data).pipe(map(() => {}));
}
private insertFacilitatorMissingTime() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators`;
  return this.apiPost<any>(path, this.data).pipe(map(() => {}));
}
private updateFacilitatorMissingTime() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators`;
  return this.apiPatch<any>(path, this.data).pipe(map(() => {}));
}
private deleteFacilitatorMissingTime() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators`;
  return this.apiDel<any>(path, this.data).pipe(map(() => {}));
}
getConfirmation(programId, classId) {
  const path = `programs/${programId}/courses/${classId}/confirmation`;
  return this.apiGet<IConfirmation>(path).pipe(
    catchError((error) => throwError(() => error)),
    map((data: IConfirmation) => data as IConfirmation)
  );
}
postConfirmation(confimrtionData: IConfirmation, programId, classId) {
  const path = `programs/${programId}/courses/${classId}/confirmation`;
  return this.apiPost<any>(path, confimrtionData).pipe(
    map((res) => res as any)
  );
}
getPersonDetail(email): Observable<any> {
  const path = `persons/${email}`;
  return this.apiGet<any>(path).pipe(
    map((data) => data as any)
  );
}
private facilitationResponse() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators?setting=true`;
  if (this.data?.facilitationResponse?.id) {
    return this.apiPatch<any>(path, this.data).pipe(map(() => {}));
  }
  return this.apiPost<any>(path, this.data).pipe(map(() => {}));
}
private insertFacilitation() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators?setting=true`;
  return this.apiPost<any>(path, this.data).pipe(map(() => {}));
}
private updateFacilitation() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators?setting=true`;
  return this.apiPatch<any>(path, this.data).pipe(map(() => {}));
}
private deleteFacilitation() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators?setting=true`;
  return this.apiDel<any>(path, this.data).pipe(map(() => {}));
}

private insertParticipation() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators?setting=true`;
  return this.apiPost<any>(path, this.data).pipe(map(() => {}));
}
private updateParticipation() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators?setting=true`;
  return this.apiPatch<any>(path, this.data).pipe(map(() => {}));
}
private deleteParticipation() {
  const path = `programs/${this.programId}/courses/${this.classId}/facilitators?setting=true`;
  return this.apiDel<any>(path, this.data).pipe(map(() => {}));
}
/* eslint-enable @typescript-eslint/no-unused-vars */
}
